import axios from '@/plugins/axios';
import utils from '@/stores/utils';

const state = {
    events: [],
    evwnts_filters: { offset: 0, limit: 20, },
    events_count: 0,
    events_errors: null,
    events_loading: false,
    events_cancel_source: null,
};

const mutations = {
    updateEvents(state, events) {
        state.events = events;
    },
    updateEventsLoading(state, loading) {
        state.events_loading = loading;
    },
    updateEventsCount(state, count) {
        state.events_count = count;
    },
    updateEventsErrors(state, errors) {
        state.events_errors = errors;
    },
    updateEventsFilters(state, filters) {
        state.events_filters = filters;
    },
    updateEventsCancelSource(state, cancel_source) {
        state.events_cancel_source = cancel_source;
    },
};

const actions = {

    async fetchEvents({ commit, dispatch, state }, params) {
        commit('updateEventsLoading', true);

        if (state.events_cancel_source) {
            state.events_cancel_source.cancel("canceled");
        }

        const cancelSource = axios.CancelToken.source();
        commit('updateEventsCancelSource', cancelSource);

        try {
            const response = await axios.get('/api/events/', {
                params: state.events_filters,
                cancelToken: state.events_cancel_source?.token
            });
            commit('updateEvents', response.data.results);
            commit('updateEventsCount', response.data.count);
            commit('updateEventsCancelSource', null);
            return response;
        } catch (xhr_error) {
            if (axios.isCancel(xhr_error)) {
                return;
            }
            const error = utils.handleError(xhr_error);
            commit('updateEventsErrors', error.details);
            throw error;
        } finally {
            commit('updateEventsLoading', false);
        }
    },

};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
